/* ATP Impact story: scroll and tap animations for the impact page. */
(function () {
  'use strict';
  var w = window, d = document;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg', XL = 'http://www.w3.org/1999/xlink';
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
  var rng = function (seed) { return function () { seed |= 0; seed = (seed + 0x6d2b79f5) | 0; var t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; };
  function el(tag, attrs, parent) {
    var n = d.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function tree(parent, x, y, s, cls) {
    var g = el('g', { transform: 'translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ') scale(' + s.toFixed(2) + ')' }, parent);
    var u = el('use', { href: '#ais-tree', x: -30, y: -58, width: 60, height: 60, 'class': cls || '' }, g);
    u.setAttributeNS(XL, 'xlink:href', '#ais-tree');
    return u;
  }
  function inView(node) { var r = node.getBoundingClientRect(); return r.bottom > 0 && r.top < w.innerHeight; }

  function init(root) {
    if (!root || root.__ais) return;
    root.__ais = true;
    if (!reduce) root.classList.add('is-live');
    var mob = w.innerWidth < 750;
    var scrollers = [];

    /* ---------- 1. hero hill ---------- */
    var hero = root.querySelector('.ais-hero');
    if (hero) {
      var g = hero.querySelector('.ais-hero__trees'), sun = hero.querySelector('.ais-hero__sun');
      var R = rng(1948), trees = [];
      var rows = [{ y0: 440, y1: 490, s: 0.62, n: mob ? 12 : 24 }, { y0: 515, y1: 560, s: 0.95, n: mob ? 10 : 19 }, { y0: 590, y1: 640, s: 1.35, n: mob ? 7 : 13 }];
      rows.forEach(function (row) {
        for (var i = 0; i < row.n; i++) {
          var x = (i + R()) / row.n * 1260 - 30;
          if (Math.abs(x - 600) < 44 && row.y0 > 580) continue; // keep room for the first sapling
          trees.push({ x: x, y: row.y0 + R() * (row.y1 - row.y0), s: row.s * (0.85 + R() * 0.3) });
        }
      });
      trees.sort(function (a, b) { return Math.hypot(a.x - 600, (a.y - 610) * 2) - Math.hypot(b.x - 600, (b.y - 610) * 2); });
      var nodes = [];
      trees.slice().sort(function (a, b) { return a.y - b.y; }).forEach(function (t) { t.node = tree(g, t.x, t.y, t.s, 'ais-t'); });
      nodes = trees.map(function (t) { return t.node; });
      requestAnimationFrame(function () { root.classList.add('is-booted'); });
      scrollers.push(function () {
        var r = hero.getBoundingClientRect();
        var p = clamp(-r.top / (r.height * 0.6), 0, 1);
        var upTo = Math.round(p * nodes.length);
        for (var i = 0; i < nodes.length; i++) nodes[i].classList.toggle('is-up', i < upTo);
        if (sun) sun.style.transform = 'translateY(' + (-150 * p).toFixed(1) + 'px)';
      });
    }

    /* ---------- 2. rolling counters ---------- */
    function roll(node) {
      var str = (node.textContent || '').trim();
      if (!/\d/.test(str) || reduce) return;
      node.setAttribute('aria-label', str);
      node.textContent = '';
      var wrap = d.createElement('span'); wrap.className = 'ais-roll'; wrap.setAttribute('aria-hidden', 'true');
      var cols = [];
      str.split('').forEach(function (ch) {
        var s = d.createElement('span');
        if (/\d/.test(ch)) {
          s.className = 'ais-roll__d';
          var col = d.createElement('span'); col.className = 'ais-roll__col';
          for (var i = 0; i < 10; i++) { var n = d.createElement('span'); n.textContent = i; col.appendChild(n); }
          s.appendChild(col); cols.push({ col: col, v: +ch });
        } else s.textContent = ch;
        wrap.appendChild(s);
      });
      node.appendChild(wrap);
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        cols.forEach(function (c, i) { c.col.style.setProperty('--rd', ((cols.length - i) * 0.08) + 's'); c.col.style.transform = 'translateY(' + (-10 * c.v) + '%)'; });
      }); });
    }

    /* ---------- 3. journey of an order ---------- */
    var jn = root.querySelector('.ais-journey');
    if (jn && !reduce) {
      var parcel = jn.querySelector('.ais-journey__parcel'), pl = jn.querySelector('.ais-pl--l'), pr = jn.querySelector('.ais-pl--r'), rib = jn.querySelector('.ais-ribbon');
      var grow = jn.querySelector('.ais-journey__grow'), bowl = jn.querySelector('.ais-journey__bowl');
      var steps = jn.querySelectorAll('.ais-step');
      var flows = jn.querySelectorAll('[data-flow]'), phone = jn.querySelector('.ais-journey__phone');
      scrollers.push(function () {
        var r = jn.getBoundingClientRect(), vh = w.innerHeight;
        var p = clamp((vh * 0.7 - r.top) / (vh * 0.7 + r.height * 0.25), 0, 1);
        var a = clamp((p - 0.08) / 0.32, 0, 1), x = 150 + 320 * a, hop = Math.abs(Math.sin(a * Math.PI * 4)) * 10 * (1 - a);
        parcel.setAttribute('transform', 'translate(' + x.toFixed(1) + ' ' + (290 - 10 * a - hop).toFixed(1) + ')');
        var b = clamp((p - 0.4) / 0.18, 0, 1);
        pl.setAttribute('transform', 'translate(' + (170 * b) + ' ' + (20 * b) + ') scale(' + (1 - 0.7 * b) + ')');
        pr.setAttribute('transform', 'translate(' + (390 * b) + ' ' + (10 * b) + ') scale(' + (1 - 0.7 * b) + ')');
        pl.style.opacity = pr.style.opacity = (1 - clamp((p - 0.5) / 0.08, 0, 1)).toFixed(2);
        rib.style.opacity = (1 - clamp(b * 5, 0, 1)).toFixed(2);
        var c = clamp((p - 0.55) / 0.25, 0, 1), e = 1 - Math.pow(1 - c, 3);
        grow.style.transform = 'scale(' + e.toFixed(3) + ')';
        bowl.style.transform = 'scale(' + e.toFixed(3) + ')';
        var st = p < 0.36 ? 0 : p < 0.6 ? 1 : 2;
        for (var i = 0; i < steps.length; i++) steps[i].classList.toggle('is-on', i === st);
        var fl = p < 0.5 ? 0 : p < 0.72 ? 1 : 2;
        for (var k = 0; k < flows.length; k++) flows[k].classList.toggle('is-on', +flows[k].getAttribute('data-flow') <= fl);
        if (phone) phone.classList.toggle('is-ordered', p > 0.05);
      });
    }

    /* ---------- 4. the long table ---------- */
    var tb = root.querySelector('.ais-table');
    if (tb) {
      var pg = tb.querySelector('.ais-table__plates'), plates = [];
      var n = mob ? 8 : 12, R2 = rng(7);
      for (var i = 0; i < n; i++) {
        var cx = 100 + (i + 0.5) * (1000 / n);
        var grp = el('g', { transform: 'translate(' + cx.toFixed(1) + ' 136)' }, pg);
        el('ellipse', { 'class': 'ais-plate', cx: 0, cy: 0, rx: 34, ry: 10 }, grp);
        var food = el('g', { 'class': 'ais-plate-food' }, grp);
        var kind = i % 3;
        if (kind === 0) { el('path', { d: 'M-22 -2 Q 0 -26 22 -2 Z', fill: '#D98A3D' }, food); el('circle', { cx: -6, cy: -10, r: 3, fill: '#6E8B3D' }, food); el('circle', { cx: 7, cy: -8, r: 2.6, fill: '#B8412E' }, food); }
        else if (kind === 1) { el('path', { d: 'M-24 -2 Q 0 -20 24 -2 Z', fill: '#E7C97A' }, food); el('ellipse', { cx: 0, cy: -9, rx: 10, ry: 4, fill: '#8C5A33' }, food); }
        else { el('path', { d: 'M-20 -2 Q 0 -22 20 -2 Z', fill: '#A9763D' }, food); el('ellipse', { cx: -8, cy: -8, rx: 5, ry: 3, fill: '#F2E6C9' }, food); el('ellipse', { cx: 6, cy: -10, rx: 5, ry: 3, fill: '#F2E6C9' }, food); }
        var steam = el('path', { 'class': 'ais-plate-steam', d: 'M-6 -30 q-3 -5 0 -10 M6 -30 q-3 -5 0 -10' }, grp);
        steam.style.setProperty('--sd', (R2() * 2).toFixed(2) + 's');
        if (i % 2 === 1 && i < n - 1) el('ellipse', { 'class': 'ais-bread', cx: 500 / n, cy: -4, rx: 12, ry: 6 }, grp);
        plates.push(food);
      }
      scrollers.push(function () {
        var r = tb.getBoundingClientRect(), vh = w.innerHeight;
        var p = clamp((vh * 0.92 - r.top) / (r.height * 0.9), 0, 1);
        var upTo = Math.ceil(p * plates.length * 1.05);
        for (var i = 0; i < plates.length; i++) plates[i].classList.toggle('is-up', i < upTo);
      });
    }

    /* ---------- 5. olive harvest ---------- */
    var hv = root.querySelector('.ais-harvest');
    var startHarvest = function () {};
    if (hv) {
      var fg = hv.querySelector('.ais-harvest__fruit'), label = hv.querySelector('[data-season]'), jar = hv.querySelector('.ais-jar__fill');
      var R3 = rng(12), fruit = [];
      var blobs = [[-13, -25, 11.5, 7], [13, -26, 12, 7.4], [0, -27, 17, 8.4], [-5, -33, 12.5, 7.6], [7, -34, 11, 7]];
      while (fruit.length < 28) {
        var bl = blobs[Math.floor(R3() * blobs.length)], ang = R3() * Math.PI * 2, rad = Math.sqrt(R3()) * 0.85;
        var ux = bl[0] + Math.cos(ang) * bl[2] * rad, uy = bl[1] + Math.sin(ang) * bl[3] * rad;
        var X = 230 + ux * 4.4, Y = 378 + uy * 4.4;
        fruit.push({ x: X, y: Y, n: el('ellipse', { 'class': 'ais-fruit', cx: X.toFixed(1), cy: Y.toFixed(1), rx: 5.2, ry: 6.4, fill: '#5E4B6B' }, fg) });
      }
      var seasons = [
        { name: 'Blossom', fill: '#FFFFFF', rx: 3.6, ry: 3.6 },
        { name: 'Green olives', fill: '#8A9A3E', rx: 5.2, ry: 6.4 },
        { name: 'Ripe olives', fill: '#5E4B6B', rx: 5.2, ry: 6.4 },
        { name: 'Harvest', fill: '#5E4B6B', rx: 5.2, ry: 6.4, drop: true }
      ];
      var si = 0, level = 0, timer = null;
      function show(k) {
        var ss = seasons[k];
        if (label) label.textContent = ss.name;
        fruit.forEach(function (f, i) {
          f.n.setAttribute('fill', ss.fill); f.n.setAttribute('rx', ss.rx); f.n.setAttribute('ry', ss.ry);
          if (ss.drop) {
            f.n.style.transitionDelay = (i * 0.04).toFixed(2) + 's';
            f.n.style.transform = 'translate(' + (440 - f.x).toFixed(1) + 'px,' + (300 - f.y).toFixed(1) + 'px) scale(.6)';
            f.n.style.opacity = '0';
          } else { f.n.style.transitionDelay = '0s'; f.n.style.transform = ''; f.n.style.opacity = '1'; }
        });
        if (ss.drop) { level = level >= 1 ? 0.25 : level + 0.25; setTimeout(function () { jar.style.transform = 'translateY(' + ((1 - level) * 132).toFixed(1) + 'px)'; }, 900); }
      }
      if (reduce) show(2);
      else {
        show(0);
        startHarvest = function () {
          if (timer) return;
          timer = setInterval(function () { si = (si + 1) % seasons.length; show(si); }, 2600);
        };
      }
    }

    /* ---------- 6. plant your own (one tree per tap; planted trees never replay) ---------- */
    var field = root.querySelector('.ais-plant__field');
    if (field) {
      var psvg = field.querySelector('.ais-plant__svg'), ptrees = field.querySelector('.ais-plant__trees'), tip = field.querySelector('[data-plant-count]');
      var planted = 0, R4 = rng(99);
      var plantAt = function (sx, sy) {
        var y = clamp(sy, 196, 272);
        var sc = 1.1 + (y - 196) / 76 * 1.1;
        var holder = d.createElementNS(NS, 'g');
        var u = tree(holder, sx, y, sc * (0.9 + R4() * 0.2), 'ais-planted');
        var gnode = holder.firstChild; gnode.__y = y;
        var before = null, kids = ptrees.children;
        for (var i = 0; i < kids.length; i++) { if (kids[i].__y > y) { before = kids[i]; break; } }
        ptrees.insertBefore(gnode, before);
        u.addEventListener('animationend', function () { u.classList.remove('ais-planted'); }, { once: true });
        if (kids.length > 80) ptrees.removeChild(kids[0]);
        planted++;
        if (tip) tip.textContent = planted === 1 ? 'You planted a tree' : 'You planted ' + planted + ' trees';
      };
      field.addEventListener('click', function (e) {
        var pt = psvg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
        var m = psvg.getScreenCTM(); if (!m) return;
        var p = pt.matrixTransform(m.inverse());
        plantAt(clamp(p.x, 10, 1190), p.y + 20);
      });
      field.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault(); plantAt(80 + R4() * 1040, 205 + R4() * 60);
      });
    }

    /* ---------- leaderboard (top three, first name and last initial only) ---------- */
    var board = root.querySelector('[data-board]');
    function renderBoard(top) {
      if (!board) return;
      var list = board.querySelector('.ais-board__list');
      if (!top || !top.length) { list.innerHTML = '<li class="ais-board__empty">Be the first on the board.</li>'; board.hidden = false; return; }
      var e2 = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      list.innerHTML = top.slice(0, 3).map(function (r, i) {
        return '<li><span class="ais-board__rank">' + (i + 1) + '</span><span class="ais-board__who"><span class="ais-board__name">' + e2(r.name) + '</span>' +
          (r.loc ? '<span class="ais-board__loc">' + e2(r.loc) + '</span>' : '') + '</span><span class="ais-board__score">' + fmt(r.score) + '</span></li>';
      }).join('');
      board.hidden = false;
    }
    if (board) {
      var burl = board.getAttribute('data-url');
      fetch(burl + (burl.indexOf('?') > -1 ? '&' : '?') + 'action=top&period=' + encodeURIComponent(board.getAttribute('data-period') || 'all'))
        .then(function (r) { return r.json(); }).then(function (r) { if (r && r.ok) renderBoard(r.top); }).catch(function () {});
    }

    /* ---------- 7. milestones (reached ones come from the live tree count) ---------- */
    var ml = root.querySelector('.ais-miles__list');
    if (ml) {
      var total = parseInt(root.getAttribute('data-trees'), 10) || 0;
      var ms = (root.getAttribute('data-milestones') || '').split(',').map(function (v) { return parseInt(v.replace(/[^0-9]/g, ''), 10); }).filter(function (v) { return v > 0; });
      ms.sort(function (a, b) { return a - b; });
      if (!ms.length) { root.querySelector('.ais-miles').hidden = true; }
      else {
        ml.style.setProperty('--n', ms.length);
        var nextMarked = false;
        ms.forEach(function (m, i) {
          var li = d.createElement('li'); li.className = 'ais-mile'; li.style.setProperty('--i', i);
          var reached = total > 0 && total >= m, tag = reached ? 'Reached' : (!nextMarked && total > 0 ? 'Next' : 'Ahead');
          if (!reached && tag === 'Next') nextMarked = true;
          li.classList.toggle('is-reached', reached); li.classList.toggle('is-next', tag === 'Next');
          li.innerHTML = '<svg class="ais-mile__leaf" viewBox="0 0 44 30" aria-hidden="true"><path d="M22 28 C 8 24 4 12 6 2 C 18 4 30 12 22 28 Z"/></svg>' +
            '<p class="ais-mile__num">' + fmt(m) + '</p><p class="ais-mile__tag">' + tag + '</p>';
          li.setAttribute('aria-label', fmt(m) + ' trees, ' + tag.toLowerCase());
          ml.appendChild(li);
        });
      }
    }

    /* ---------- 10. closing sunset ---------- */
    var sn = root.querySelector('.ais-sunset');
    if (sn) {
      var sg = sn.querySelector('.ais-sunset__trees'), ssun = sn.querySelector('.ais-sunset__sun'), R5 = rng(5);
      var cnt = mob ? 16 : 30;
      for (var k = 0; k < cnt; k++) { var tx = (k + R5()) / cnt * 1240 - 20; tree(sg, tx, 452 + R5() * 28, 1.1 + R5() * 0.5); }
      if (!reduce) scrollers.push(function () {
        var r = sn.getBoundingClientRect(), vh = w.innerHeight;
        var p = clamp((vh - r.top) / (r.height + vh * 0.4), 0, 1);
        ssun.style.transform = 'translateY(' + (160 * p - 60).toFixed(1) + 'px)';
      });
    }

    /* ---------- in view: counters, stitching, harvest ---------- */
    var views = root.querySelectorAll('[data-ais-view]');
    function reveal(sec) {
      if (sec.classList.contains('is-inview')) return;
      sec.classList.add('is-inview');
      Array.prototype.forEach.call(sec.querySelectorAll('[data-ais-roll]'), roll);
      if (sec === hv) startHarvest();
    }
    if (reduce || !('IntersectionObserver' in w)) Array.prototype.forEach.call(views, reveal);
    else {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); reveal(e.target); } }); }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      Array.prototype.forEach.call(views, function (v) { if (inView(v)) reveal(v); else io.observe(v); });
    }

    /* ---------- scroll loop ---------- */
    var ticking = false;
    function frame() { ticking = false; scrollers.forEach(function (f) { try { f(); } catch (e) {} }); }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    w.addEventListener('scroll', req, { passive: true });
    w.addEventListener('resize', req);
    frame();
  }

  function boot() { Array.prototype.forEach.call(d.querySelectorAll('[data-ais]'), function (r) { try { init(r); } catch (e) { r.classList.remove('is-live'); } }); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', boot);
})();
